module.exports = __webpack_public_path__ + "img/denmark-diabetes-mellitus-male.e49400bb.png";